<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6xD3a1/tc-custom/9780802190123.jpg?1721704349569" alt="This image is the cover for the book Black Widow, The Jack Parlabane Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Widow, The Jack Parlabane Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>A “hair-raising . . . devilishly complicated mystery” from the Scottish crime master. “</b><b>Don’t even try to guess the outcome” (<i>The </i></b><b><i>New York Times Book Review</i></b><b>).</b><br/>  <br/> Diana Jager is clever, strong, and successful, a skilled surgeon and fierce campaigner via her blog about sexism in medicine. Yet it takes only hours for her life to crumble when her personal details are released on the internet as revenge for her writing.<br/>  <br/> Then Diana meets Peter. He is kind, generous, and knows nothing about her past—the second chance she’s been waiting for. Within six months, they are married. Within six more, Peter is dead in a road accident, a nightmare end to their fairy-tale romance. But Peter’s sister doesn’t believe in fairy tales, and tasks rogue reporter Jack Parlabane with discovering the dark truth behind the woman the media is calling the Black Widow.<br/>  <br/> Still on the mend from a turbulent divorce, Jack’s investigation into matters of the heart takes him to hidden places no one should ever have to go.<br/>  <br/><b>Winner of the 2017 Theakson Old Peculier Crime Novel of the Year Award and the 2016 McIlvanney Prize for Scottish Crime Book of the Year</b><br/>  <br/> “Brookmyre excels at melding the true chills of a psychological thriller with rollicking—if dark—humor. A witty and wild page-turner, <i>Black Widow </i>shines in showcasing this winning combination.” —<i>The </i><i>Boston Globe</i><br/>  <br/> “Exceptionally good—a knotty mystery that’s . . . one of the most perceptive excavations of a dysfunctional marriage I can remember reading.” —<i>The </i><i>Guardian </i>(UK)<br/>  <br/> “A tense and provocative read.” —<i>Entertainment Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Brookmyre
      </h2>
      
      <p class="authorDescription body article">Christopher Brookmyre was a journalist before publishing his award-winning debut, <I>Quite Ugly One Morning</I>. He is the author of the Jack Parlabane Thrillers, which have sold more than one million copies in the UK alone, and the acclaimed Jasmine Sharp and Catherine McLeod Novels. He has won many awards for his work, including the McIlvanney Prize for Best Scottish Crime Novel of the Year, the Bollinger Everyman Wodehouse Prize, and the Glenfiddich Spirit of Scotland Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atlantic Monthly Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ee0944e8